import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDyC3hbzN0ZoKHsQxGkvNrxsTCkOK-CEko",
  authDomain: "my-razum.firebaseapp.com",
  projectId: "my-razum",
  storageBucket: "my-razum.firebasestorage.app",
  messagingSenderId: "360232344369",
  appId: "1:360232344369:web:77dd667906e445554cee10",
  measurementId: "G-W56V9JXBQV",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Initialize Firebase Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);